export const AUTH_TOKEN = 'access_token';
export const USER = 'user';

//Create Items Pagination
export const LINKS_PER_PAGE = 20;

// Define in which environment sentry should run on
export const SENTRY_ENVIRONMENT = 'production';
